import { productGalleryPopup } from '../../modules/Slider.js';


jQuery(function($){

    let $productPage = $('.single-product-page');
    if ($productPage.length == 0){
        return;
    }

    let $product = $productPage.find('.single-product');


    // Info switch under the gallery
    $('.product-info__btn').on('click', function(){
        let tab = $(this).data('tab');
        $('.product-info__btn').removeClass('active');
        $(this).addClass('active');
        $('.product-info__tab-content').removeClass('active');
        $('.product-info__tab-content[data-tab=' + tab + ']').addClass('active');
    });

    // Open popup gallery
    $('[data-popup="popup-gallery"]').on('click', function(){
        let index = $('.product-gallery__slider.main-slider .swiper-slide-active').data('swiper-slide-index');
        productGalleryPopup.slideTo(index);
    });

    /* Config code */

    let config = $('.config');

    function generateUniqueId() {
        return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
    }

    let productId = $product.data('product-id');
    let productNaam = $product.data('product-naam');
    let productCategory = $product.data('product-category');
    let productFotoUrl = $product.data('product-foto-url');
    let productUrl = window.location.href;
    let montageVerplicht = parseInt($product.data('montage-verplicht'));

    let data = {
        'id' : generateUniqueId(),
        'productId' : productId,
        'productNaam' : productNaam,
        'productCategory' : productCategory,
        'productUrl' : productUrl,
        'productFotoUrl' : productFotoUrl, 
        'opties' : {},
        'montage' : montageVerplicht ? 1 : 0,
        'montageVerplicht' : montageVerplicht,
        'referentie' : '',
        'standaardmaat' : 0
    }

    config.find('.config__stap[data-stap="1"]').addClass('active');

    // Als er in de URL een id staat van een al toegevoegd product. Verander de data dan naar die van dat ID
    // Get the 'id' from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    if (id) {
        
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_from_cart', 
                id: id,
                _wpnonce: wemake.nonce,
            },
            success: function(response) {
                if (response.success) {
                    data = response.data; 
                    console.log(data);
                    
                    initConfig();
                    $('.popup-cart .popup__title').text('Product is gewijzigd');
                    $('.config__add-to-cart').text('Wijzig dit product');
                    
                } else {
                    removeIdFromUrl(); 
                }
            },
            error: function(e) {
                removeIdFromUrl(); 
            }
        });
        scrollToActiveStep();
    }

    // Function to remove the 'id' parameter and reload the page
    function removeIdFromUrl() {
        const currentUrl = window.location.href;
        const newUrl = currentUrl.split('?')[0]; // Remove the query string
        window.location.href = newUrl; // Reload the page without the id
    }

    // Init the config based on whats in the data variable
    function initConfig(){
        let radioStep = $('.config__stap-radio');
        radioStep.each(function(){
            let $step = $(this);
            let name = $step.data('naam');
            let value = data['opties'][name];
            
            if (value.startsWith('Eigen')){
                $step.find('.config__eigen').addClass('done');
                $step.find('.config__eigen-input input').val(value);
                $step.find('.config__eigen-val').text(value);
            }
            else{
                // Set the choice right
                $step.find('.config__stap-keuze').each(function(){
                    let input = $(this).find('input');
                    if (input.val() == value){
                        $(this).addClass('active');
                        input.prop('checked', true);
                        input.trigger('change');
                    }
                });
            }
            // Set the value
            $step.attr('data-value', value);
        });

        let checkboxStep = $('.config__stap-checkbox');
        checkboxStep.each(function(){
            let $step = $(this);
            let step = $step.data('stap');
            let name = $step.data('naam');
            let value = data['opties'][name];
            
            if (value.startsWith('Eigen')){
                $step.find('.config__eigen').addClass('done');
                $step.find('.config__eigen-input input').val(value);
                $step.find('.config__eigen-val').text(value);
            }
            else{
                let dataValues = value.split(' & ');
                
                $step.find('.config__stap-keuze').each(function(){
                    let input = $(this).find('input');
                    if (dataValues.includes(input.val())) {
                        $(this).addClass('active');
                        input.prop('checked', true);
                        input.trigger('change');

                        // Handle dependencies
                        if (input.data('mogelijkheden')){
                            handleDependencies(input.data('mogelijkheden'), step + 1);
                        }
                    }
                });     
            }
            // Set the value
            $step.attr('data-value', value);
        });

        let numberStep = $('.config__stap-number');
        numberStep.each(function(){
            let $step = $(this);
            let step = $step.data('stap');
            let $inputs = $step.find('input[type="number"], input[type="text"]');

            $inputs.each(function(){
                let $input = $(this);
                let name = $input.data('key');

                if (name == 'qty'){
                    let value = data[name];
                    $input.val(value);
                    $('.config__val[data-key="' + name + '"] .config__qty').text(value);
                    $('.config__val[data-key="' + name + '"]').addClass('active');
                    $('.config__summary .config__qty').text(value);
                    $('.popup-cart-qty').text(value);
                }
                else{
                    let value = data['opties'][name];
                    
                    $input.val(parseInt(value));
                }
            });

            let selectedValue = data['opties']['positie-zijlicht'];

            let radioInput = $step.find(`input[type="radio"][value="${selectedValue}"]`);

            if (radioInput.length > 0) {
                radioInput.prop('checked', true);
            }

            setValueNumberStep(step)
        });


        updateAll();
    }


    /* General events & helper functions */
    config.find('.config__stap-upper').on('click', changeStep);

    function changeStep(){
        config.find('.config__stap').removeClass('active');

        let step = $(this).data('stap');
        let $step = $('.config__stap[data-stap="' + step + '"]');

        $step.addClass('active');

        // Clear any previous timeout to reset the delay
        if (nextStepTimeout !== null) {
            clearTimeout(nextStepTimeout);
        }
        // Scroll to the active step with offset
        scrollToActiveStep();
        updateAll();     
    }

    // Function that checks for every step if it's done or not
    function updateAll(){
        config.find('.config__stap-number').each(function(){
            let $step = $(this);
            let step = $step.data('stap');
            let $stepVal = $step.find('.config__stap-val');
            if (allInputsFilled(step)){
                $step.addClass('done');
                $stepVal.text($step.attr('data-value'));
            }
            else{
                $step.removeClass('done');
                $stepVal.text('');
            }
        });

        config.find('.config__stap-radio, .config__stap-checkbox').each(function(){
            let $step = $(this);
            let $stepVal = $step.find('.config__stap-val');
            
            if ($step.attr('data-value') != ''){
                $step.addClass('done');
                $stepVal.text($step.attr('data-value'));
            }
            else{
                $step.removeClass('done');
                $stepVal.text('');
            }
        });   

        // Update the summary
        updateSummary();
    }


    function goToNextStep(currentStep){
        updateAll();

        /*
        The logic for determining the next step
        */
        if (currentStep > 0){
            let $currentStep = $('.config__stap[data-stap=' + currentStep + ']');
            $currentStep.removeClass('active');
        }
        else{
            currentStep = 0;
        }

        let nextStep = currentStep + 1;
        let $nextStep = $('.config__stap[data-stap=' + nextStep + ']');

        while ($nextStep.hasClass('done')) {
            nextStep++;
            $nextStep = $('.config__stap[data-stap=' + nextStep + ']');
        }

        // If the next step is the summary and one of the other steps isn't done. 
        // Go to the step that isnt done
        if ($nextStep.hasClass('config__last-step')){
            if (config.find('.config__stap:not(.config__last-step):not(.done)')[0]){
                $nextStep = $(config.find('.config__stap:not(.config__last-step):not(.done)')[0]);
            }
        }

        // If there is a next 
        if ($nextStep.length > 0) {
            $nextStep.addClass('active'); 
        }    

        scrollToActiveStep();
    }
    

    function scrollToActiveStep(){
        // Scroll to the active step with offset
        let offset = $('.site-header').outerHeight(); 
        if ($('#wpadminbar').length > 0){
            offset += 32;
        }
        offset += 30;
        let offsetTop = config.find('.config__stap.active').offset().top;

        window.scroll({
            top: offsetTop - offset, 
            behavior: "smooth" 
        });
    }

    function resetStep(step){
        let $step = $('.config__stap[data-stap=' + step + ']');
        $step.find('input[type="radio"]').prop('checked', false);
        $step.find('input[type="text"], input[type="number"]').val('');
        $step.find('.config__stap-keuze').removeClass('active');
        $step.find('[data-benodigdheden]').removeClass('active-prop');
        $step.find('[data-benodigdheden]').addClass('inactive');
        $step.attr('data-value', '');
        $step.removeClass('done');
    }

    /* Handling Radio Step */
    let nextStepTimeout = null;

    let radioSteps = $('.config__stap-radio');

    radioSteps.each(function(){
        let $step = $(this);
        let step = $step.data('stap');

        $step.find('input[type="radio"]').on('change', function(){
            let option = $(this);
            let $keuze = $(this).closest('.config__stap-keuze');
            
            if (option.is(':checked')) {     
                // Reset any steps this step has an influence on
                
                let influences = $step.data('influences');
                if (influences){
                    influences.forEach(function(influence){   
                        resetStep(influence);
                        if (option.data('mogelijkheden')){
                            handleDependencies(option.data('mogelijkheden'), influence);
                        }
                    });
                }

                handleDisablingChoices($keuze);
                
                // Change the choice
                $step.find('.config__stap-keuze').removeClass('active');
                option.closest('.config__stap-keuze').addClass('active');
  
                // Set the value
                $step.attr('data-value', option.val());
                data['opties'][$step.data('naam')] = option.val();

                // Als de klant een eigen keuze had gemaakt, verwijder deze
                $step.find('.config__eigen').removeClass('done');
                $step.find('.config__eigen').removeClass('active');

                // Reset the users own input if it exists
                if ($step.find('.config__eigen-input input').length > 0){
                    $step.find('.config__eigen-input input').val('');
                }

                // Clear any previous timeout to reset the 
                if (nextStepTimeout !== null) {
                    clearTimeout(nextStepTimeout);
                }

                // Set a new timeout to go to the next step
                nextStepTimeout = setTimeout(function(){
                    goToNextStep(step);
                }, 400);
            }
            else{
                option.closest('.config__stap-keuze').removeClass('active');
            }     
        });  
        
        // Als de eigen kleur inactief is
        $step.find('.config__eigen--inactief .btn').on('click', function(){
            $step.find('.config__eigen').addClass('active');
            // Clear any previous timeout to reset the delay
            if (nextStepTimeout !== null) {
                clearTimeout(nextStepTimeout);
            }
        });

        // Als de kleur actief is
        $step.find('.config__eigen--actief .btn').on('click', function(){
            let value = $step.find('.config__eigen-input textarea').val();

            if (value != 0 && value != ''){         
                // Update de waardes van de stap
                let label = $step.find('.config__eigen textarea').attr('name');
                $step.attr('data-value', label + ': ' + value);
                data['opties'][$step.data('naam')] = label + ': ' + value;
                $('.config__eigen-val').text(value);

                // Remove the check from the radio buttons
                $step.find('input[type="radio"]').prop('checked', false);
                $step.find('.config__stap-keuze').removeClass('active');

                // Update de eigen input sectie
                $step.find('.config__eigen').addClass('done');
                $step.find('.config__eigen').removeClass('active');

                goToNextStep(step);
            }
            else{
                alert('Vul een aub waarde in');
            }
            
        });

        // Als de kleur al gekozen is
        $step.find('.config__eigen-wijzig').on('click', function(){
            $step.find('.config__eigen').addClass('active');
            $step.find('.config__eigen').removeClass('done');
        });
    });



    // Handling checkbox steps
    let checkboxSteps = $('.config__stap-checkbox');

    checkboxSteps.each(function(){
        let $step = $(this);
        let step = $step.data('stap');
        let dataValues = [];

        $step.find('input[type="checkbox"]').on('change', function(){
            let option = $(this);
            dataValues = [];

            $step.find('input[type="checkbox"]').each(function(){
                if ($(this).is(':checked') && option.val() != $(this).val()){
                    dataValues.push($(this).val()); 
                }
            });

            if ($step.find('input[type="checkbox"]').is(':checked')){
                $step.find('.config__next-stap-btn').removeClass('btn--inactive');
            }
            else{
                $step.find('.config__next-stap-btn').addClass('btn--inactive');
            }
            
            if (option.is(':checked')) {     
                // Reset any steps this step has an influence on
                let influences = $step.data('influences');
                if (influences){
                    influences.forEach(function(influence){   
                        resetStep(influence);

                        if (option.data('mogelijkheden')){
                            handleDependencies(option.data('mogelijkheden'), influence);
                        }
                    });
                }

                // Change the choice
                // Right now it's all based on the removing option being called "Geen opties"
                // Improving this would mean adding an ACF checkbox to the choice and using a class for this
                option.closest('.config__stap-keuze').addClass('active');

                if (option.val() == "Geen opties" || option.val() == "Vast raam"){
                    dataValues = [];
                    $step.find('.config__stap-keuze').removeClass('active');
                    $step.find('input[type="checkbox"]').prop('checked', false);
                    $(this).prop('checked', true);
                }
                else{
                    const index = dataValues.indexOf('Geen opties');
                    if (index > -1) { 
                        dataValues.splice(index, 1); 
                    }
                    const index2 = dataValues.indexOf('Vast raam');
                    if (index2 > -1) { 
                        dataValues.splice(index2, 1); 
                    }
                    let removalOption = $step.find('input[type="checkbox"][value="Geen opties"], input[type="checkbox"][value="Vast raam"]').prop('checked', false);
                    removalOption.closest('.config__stap-keuze').removeClass('active');
                }

                // Set the value
                dataValues.push(option.val());
                var concatenatedValues = dataValues.join(' & ');

                $step.attr('data-value', concatenatedValues);
                data['opties'][$step.data('naam')] = concatenatedValues;

                // Als de klant een eigen keuze had gemaakt, verwijder deze
                $step.find('.config__eigen').removeClass('done');
                $step.find('.config__eigen').removeClass('active');

                // Reset the users own input if it exists
                if ($step.find('.config__eigen-input input').length > 0){
                    $step.find('.config__eigen-input input').val('');
                }       
            }
            else{
                option.closest('.config__stap-keuze').removeClass('active');
                const index = dataValues.indexOf(option.val());
                if (index > -1) { 
                    dataValues.splice(index, 1); 
                }
                var concatenatedValues = dataValues.join(' & ');

                $step.attr('data-value', concatenatedValues);
                data['opties'][$step.data('naam')] = concatenatedValues;
            }    
            
        });  
        
        // Als de eigen keuze inactief is
        $step.find('.config__eigen--inactief .btn').on('click', function(){
            $step.find('.config__eigen').addClass('active');
            // Clear any previous timeout to reset the delay
            if (nextStepTimeout !== null) {
                clearTimeout(nextStepTimeout);
            }
        });

        // Als de eigen keuze actief is
        $step.find('.config__eigen--actief .btn').on('click', function(){
            let value = $step.find('.config__eigen-input textarea').val();

            if (value != 0 && value != ''){         
                // Update de waardes van de stap
                let label = $step.find('.config__eigen textarea').attr('name');
                $step.attr('data-value', label + ': ' + value);
                data['opties'][$step.data('naam')] = label + ': ' + value;
                $('.config__eigen-val').text(value);

                // Remove the check from the radio buttons
                $step.find('input[type="checkbox]').prop('checked', false);
                $step.find('.config__stap-keuze').removeClass('active');

                // Update de eigen input sectie
                $step.find('.config__eigen').addClass('done');
                $step.find('.config__eigen').removeClass('active');

                goToNextStep(step);
            }
            else{
                alert('Vul een aub waarde in');
            }
            
        });

        // Als de eigen keuze al gekozen is
        $step.find('.config__eigen-wijzig').on('click', function(){
            $step.find('.config__eigen').addClass('active');
            $step.find('.config__eigen').removeClass('done');
        });

        $step.find('.config__next-stap-btn').on('click', function(e){
            e.preventDefault();
            // Check if at least one is checked
            if ($step.find('input[type="checkbox"]').is(':checked')){
                // Reset any steps this step has an influence on
                let influences = $step.data('influences');
                if (influences){
                    influences.forEach(function(influence){   
                        resetStep(influence);
                    });
                }

                goToNextStep(step);
            }    
        });
    });
    

    // Handling of the numbersteps

    let numberSteps = $('.config__stap-number');

    numberSteps.each(function(){
        let $step = $(this);
        let step = $step.data('stap');

        $step.find('input[type="text"], input[type="number"]').on('input', function(){
            let key = $(this).data('key');
            let value = $(this).val().replace(/^0+/, '');

            if (allInputsFilled(step)){
                $step.find('.config__next-stap-btn').removeClass('btn--inactive');
            }
            else{
                $step.find('.config__next-stap-btn').addClass('btn--inactive');
            }
            
            // Change the qty field in the summary
            if (key == 'qty'){
                if (value != '' && value != '0' && value != 0){
                    $('.config__summary .config__qty').text(value);
                    $('.config__val[data-key="' + key + '"]').addClass('active');
                    data[key] = parseInt(value);
                    $('.popup-cart-qty').text(value);
                }
                else{
                    $('.config__summary .config__qty').text(value);
                    $('.config__val[data-key="' + key + '"]').removeClass('active');
                    data[key] = parseInt(value);
                    $('.popup-cart-qty').text(value);
                }        
            }
            else {
                setValueNumberStep(step);
                data['opties'][key] = value + ' mm';
            }   
        });  
        
        // voor de positie van de zijlichten
        $step.find('input[type="radio"]').on('change', function(){
            let key = $(this).attr('name');
            let value = $(this).val();  
            data['opties'][key] = value;

            if (allInputsFilled(step)){
                $step.find('.config__next-stap-btn').removeClass('btn--inactive');
            }
            else{
                $step.find('.config__next-stap-btn').addClass('btn--inactive');
            }
        });
        
        $step.find('.config__next-stap-btn').on('click', function(e){
            e.preventDefault();
            if (allInputsFilled(step)){
                // Reset any steps this step has an influence on
                let influences = $step.data('influences');
                if (influences){
                    influences.forEach(function(influence){   
                        resetStep(influence);
                    });
                }

                removeInactiveData(step);

                goToNextStep(step);
            }    
        });   
    });

    function removeInactiveData(step) {
        let $step = $('.config__stap[data-stap=' + step + ']');
    
        $step.find('label.inactive input').each(function () {
            let name = $(this).attr('name');
    
            if (name && data['opties'].hasOwnProperty(name)) {
                delete data['opties'][name];
            }
        });
    }

    function setValueNumberStep(step){
        let $step = $('.config__stap[data-stap=' + step + ']');
        let inputs = $step.find('label:not(.inactive) input');
        let stepValue = '';
        inputs.each(function(){
            let input = $(this);
            let value = input.val();
            if (value != '' && value != '0' && value != 0){
                if (input.data('key') == 'breedte'){
                    stepValue += value + ' mm breed x ';
                }
                if (input.data('key') == 'hoogte'){
                    stepValue +=  value + ' mm hoog ';
                }
                if (input.data('key') == 'zijlicht'){
                    stepValue += '(' + value + ' mm zijlicht(en)) ';
                }
                if (input.data('key') == 'bovenlicht'){
                    stepValue += '(' + value + ' mm bovenlicht)';
                }
            }
        });

        $step.attr('data-value', stepValue);
    }

    function allInputsFilled(step){
        let $step = $('.config__stap[data-stap=' + step + ']');
        let inputs = $step.find('label:not(.inactive) input[type="text"], label:not(.inactive) input[type="number"]');
        let radioInputs = $step.find('label:not(.inactive) input[type="radio"]');

        let allFilled = true;
        
        inputs.each(function(){
            if ($(this).val() == '' || $(this).val() == '0' || $(this).val() == 0 ){
                allFilled = false;
            }
        });
        if (radioInputs.length > 0 && !radioInputs.is(':checked')){
            allFilled = false;
        }

        return allFilled;
    }

    function handleDependencies(mogelijkheden, step) {
        let $step = $('.config__stap[data-stap=' + step + ']');
        // Iterate over all elements that have data-benodigdheden
        $step.find('[data-benodigdheden]').each(function () {
            let element = $(this);
            let benodigdheden = element.data('benodigdheden'); // Get data attribute
    
            if (typeof benodigdheden === 'string') {
                benodigdheden = benodigdheden.replace(/[\[\]]/g, '').split(', '); // Convert to array
            } else if (!Array.isArray(benodigdheden)) {
                benodigdheden = []; // Default to empty array if invalid
            }
    
            // Check if all benodigdheden exist in mogelijkheden
            let allMatched = benodigdheden.every(benodigheid => mogelijkheden.includes(benodigheid));
    
            if (allMatched) {
                element.addClass('active-prop').removeClass('inactive');
            } else {
                element.removeClass('active-prop').addClass('inactive');
            }
        });
    }


    function handleDisablingChoices($keuze) {
        let andereKeuzesStap = $keuze.siblings('.config__stap-keuze');

        function parseDataList(str) {
            if (!str) return [];
            return str
                .replace(/[\[\]]/g, '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean);
        }

        const keuzeVerbergen = parseDataList($keuze.attr('data-verbergen'));
        const keuzeUitschakelen = parseDataList($keuze.attr('data-uitschakelen'));
        const popupUitschakelen = $keuze.data('popup-uitschakelen');

        let siblingsVerbergen = [];
        let siblingsUitschakelen = [];

        andereKeuzesStap.each(function () {
            let $ander = $(this);
            siblingsVerbergen.push(...parseDataList($ander.attr('data-verbergen')));
            siblingsUitschakelen.push(...parseDataList($ander.attr('data-uitschakelen')));
        });

        const uniqueKeuzeVerbergen = [...new Set(keuzeVerbergen)];
        const uniqueKeuzeUitschakelen = [...new Set(keuzeUitschakelen)];
        const uniqueSiblingsVerbergen = [...new Set(siblingsVerbergen)];
        const uniqueSiblingsUitschakelen = [...new Set(siblingsUitschakelen)];

        uniqueSiblingsVerbergen.forEach(name => {
            $(`.config__stap-keuze[data-naam="${name}"]`).removeClass('hidden');
            resetDepency(name);
        });
        uniqueSiblingsUitschakelen.forEach(name => {
            let $keuze = $(`.config__stap-keuze[data-naam="${name}"]`);
            $keuze.removeClass('disabled');
            $keuze.removeClass('open-popup').removeAttr('data-popup');
                $keuze.find('.config__stap-keuze-uitgeschakeld').remove();
            resetDepency(name);
        });

        uniqueKeuzeVerbergen.forEach(name => {
            $(`.config__stap-keuze[data-naam="${name}"]`).addClass('hidden');
            resetDepency(name); 
        });
        uniqueKeuzeUitschakelen.forEach(name => {
            let $keuze = $(`.config__stap-keuze[data-naam="${name}"]`);
            $keuze.addClass('disabled');
            if (popupUitschakelen){
                $keuze.addClass('open-popup').attr('data-popup', popupUitschakelen);
                $keuze.find(`.config__stap-keuze-content`).append(
                `<div class="d-f f-a-c gap-4 t-13 fw-n config__stap-keuze-uitgeschakeld">
                    <img width="18" height="18" src="/wp-content/themes/wemake/images/info.svg">
                    <span>Combinatie niet mogelijk</span>
                </div>`);
            }
            resetDepency(name);
        });

        function resetDepency(name){
            // Reset the step that has that choice in there.
            let step = $(`.config__stap-keuze[data-naam="${name}"]`).closest('.config__stap').data('stap');
            resetStep(step);
        }
    }

    $(document).on('click', '.config__stap-keuze.open-popup', function(){
        let popup = $(this).data('popup-uitschakelen');
        let $popup = $('#' + popup);
        $popup.attr('data-keuze-naam', $(this).data('naam'));
    });

    $(document).on('click', '.popup-confirm-choice', function(){
        let keuzeNaam = $(this).closest('.popup').attr('data-keuze-naam');
        let aanzettenNaam = $(this).closest('.popup').data('aanzetten');
        let $keuze = $(`.config__stap-keuze[data-naam="${keuzeNaam}"]`);
        let $aanzetten = $(`.config__stap-keuze[data-naam="${aanzettenNaam}"]`);
        
        $aanzetten.find('input').prop('checked', true).trigger('change');

        setTimeout(function(){
            $keuze.find('input').prop('checked', true).trigger('change');
        });
        
    });
    

    /* The summary code */
    function updateSummary(){
        let $steps = $('.config__stap:not(.config__last-step)');
        let allStepsCompleted = true;
        let $submitBtn = $('.config__add-to-cart');

        // Update the summary for all steps and check if everything is done
        $steps.each(function(){
            let $step = $(this);
            let step = $step.data('stap');
            let value = $step.attr('data-value');

            if (value != ''){
                $('.config__summary-step[data-stap="' + step + '"] .config__summary-val').text(value);
                $('.config__summary-step[data-stap="' + step + '"]').addClass('done');
            }
            else{
                $('.config__summary-step[data-stap="' + step + '"] .config__summary-val').text('-');
                $('.config__summary-step[data-stap="' + step + '"]').removeClass('done');
            }
                  
            // Check if all is done
            if (!$step.hasClass('done') || value == ''){
                allStepsCompleted = false;
            }
        });


        if (allStepsCompleted) {
            $submitBtn.removeClass('btn--inactive').prop('disabled', false);
            $('.config__summary-text').addClass('hidden');
        } else {
            $submitBtn.addClass('btn--inactive').prop('disabled', true);
            $('.config__summary-text').removeClass('hidden');
        }
    }

    $('.config__summary-open').on('click', changeStep);
    $('.config__summary-wijzig').on('click', changeStep);
    $('.config__summary-sluit').on('click', function(){
        goToNextStep(0);
        let step = $(this).data('stap');
        $('.config__stap[data-stap=' + step + ']').removeClass('active');
    });



    $('.config__add-to-cart').on('click', function(e){
        e.preventDefault();
        console.log(data);
        
        // Make an AJAX request to the backend to add the product to the offertemand
        $.ajax({ 
            url: wemake.ajax_url,
            type: 'POST',
            data: {
                action: 'add_to_cart', 
                data: data,
                _wpnonce: wemake.nonce,
            },
            beforeSend: function(){
                $('.popup-add-to-cart__options').html('<div class="spinner-loader"></div>');
            },

            success: function(response){
                console.log(response.data);

                if (response.success) {

                    let options = response.data.added.opties;
                    let $popupOptions = $('.popup-add-to-cart__options');
                
                    $popupOptions.empty();
                
                    let afmetingen = null;
                
                    // Build key-value spans
                    for (let key in options) {
                        if (options.hasOwnProperty(key)) {
                            let value = options[key];
                
                            // Collect breedte and hoogte into afmetingen
                            if (key.toLowerCase() === 'breedte' || key.toLowerCase() === 'hoogte') {
                                afmetingen = afmetingen || {};
                                afmetingen[key.toLowerCase()] = value;
                                continue; // skip normal output
                            }
                
                            let formattedKey = key.replace(/-/g, ' ');
                            formattedKey = formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
                
                            let $optionSpan = $('<span></span>').html(`${formattedKey}: <strong>${value}</strong>`);
                            $popupOptions.append($optionSpan);
                        }
                    }
                
                    // Add afmetingen if available
                    if (afmetingen && afmetingen['breedte'] && afmetingen['hoogte']) {
                        let afmetingenText = `${afmetingen['breedte']} breed x ${afmetingen['hoogte']} hoog`;
                        let $afmetingenSpan = $('<span></span>').html(`Afmetingen: <strong>${afmetingenText}</strong>`);
                        $popupOptions.prepend($afmetingenSpan);
                    }
                
                    const totalCount = response.data.total_count;
                    $('.offerte-counter__count').text(totalCount);
                   
                    // Change the ID in the data in case they want to add another product. That will have a unique ID then.
                    data['id'] = generateUniqueId();
     
                }
            },
            error: function(error) {
                console.error('Error adding product to cart:', error);
            }
        });
        
    });


    function setCartcount(){
        $.ajax({ 
            url: wemake.ajax_url,
            type: 'GET',
            data: {
                action: 'get_cart_count', 
                data: data,
                _wpnonce: wemake.nonce,
            },
            beforeSend: function(){
                
            },

            success: function(response){
                if (response.success){
                    $('.offerte-counter__count').text(response.data);
                }
            },
            error: function(error) {
                console.error('Error getting cart count:', error);
            }
        });
    }

    setCartcount();
});